// extracted by mini-css-extract-plugin
export default {"cardWrapper":"U3BRsV","optionCard":"BneH73","preselected":"WxStJj","additionalOption":"pgLDdD"};